import React from 'react'
import { t } from '../../../utils/i18n'
import Card from '../card/card'
import { AppList } from '../../../pages/overview'
import { useFavorites } from '../../../context/FavoritesContext'
import './favorite-section.scss'

export type FavSection = {
  appList?: AppList | null
  isLoading?: boolean
}

export const FavoriteSection = ({ appList, isLoading }: FavSection) => {
  const { favorites } = useFavorites()

  const filteredFavApps = appList?.data?.map((item) =>
    item.apps.filter((app) => favorites?.includes(app?.appSysId))
  )

  const renderLoadingState = () => {
    return (
      <section className="fav-section-pulsating">
        <h1 className="h1"></h1>
        <p className="body-sm"></p>
        <div className="card-group">
          {[...Array(3)].map((_, i) => (
            <div className="card" key={i}></div>
          ))}
        </div>
        <hr className="fav-divider divider" />
      </section>
    )
  }

  return isLoading ? (
    renderLoadingState()
  ) : (
    <section className="fav-section">
      <h1>{t('fav.section.title')}</h1>
      <p className="body-sm">{t('fav.section.desc')}</p>
      <div className="card-group">
        {filteredFavApps?.map((app, i) => {
          return app.map((item) => {
            const isFavorite = favorites?.includes(item.appSysId)
            return (
              <Card
                key={i}
                title={item.name}
                description={item.description}
                isFavorite={isFavorite}
                icon={item.signedUrlForLogo}
                appSysId={item?.appSysId}
                link={item?.landingPageUrl}
              />
            )
          })
        })}
      </div>
      <hr className="fav-divider divider" />
    </section>
  )
}

export default FavoriteSection
